import { defineComponent } from "vue";

/**
 * 渲染 `Home` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Home = defineComponent({
	name: "Home",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M929.1744 436.3712L621.5488 128.63573333c-59.2992-59.2-155.62666667-59.2-214.9248 0L99.09546667 436.26773333c-28.69333333 28.69333333-44.48213333 66.77546667-44.48213334 107.41333334 0 21.44106667 4.47786667 42.34666667 12.9056 61.3312a4.096 4.096 0 0 0 6.61333334 1.17333333l207.78666666-207.67786667 197.3344-197.33333333a49.2608 49.2608 0 0 1 34.88213334-14.40213333c12.69226667 0 25.27466667 4.8 34.87573333 14.40106666l198.08853333 198.0832 207.03893334 207.03893334a4.096 4.096 0 0 0 6.61333333-1.17333334 151.63413333 151.63413333 0 0 0 12.9056-61.3312c-0.00533333-40.64426667-15.7888-78.72533333-44.4832-107.41973333z" />
				<path d="M526.9312 249.49546667a18.09386667 18.09386667 0 0 0-25.712 0L180.90133333 569.81333333a30.5888 30.5888 0 0 0-8.96213333 21.6544v246.08213334c0 57.91786667 46.9344 104.85333333 104.85226667 104.85333333h110.18773333a20.14186667 20.14186667 0 0 0 20.15786667-20.1536V684.27733333c0-12.16746667 15.04-17.6064 25.81546666-17.6064h162.45866667c12.37546667 0 25.81546667 6.7168 25.81546667 17.6064v237.97333334c0 11.08586667 8.96213333 20.15146667 20.15786666 20.15146666h110.18773334c57.91786667 0 104.85226667-47.03786667 104.85226666-104.85226666V591.46773333a30.58346667 30.58346667 0 0 0-8.96746666-21.65333333L526.9312 249.4944z" />
			</svg>
		);
	},
});

export default Home;
